import React from 'react';
import Image from 'next/image';

import { YearlyPriceData } from './types';

import { PricePredictionButton } from './PricePredictionButton';

interface YearlyPricePredictionProps {
  btn_link?: string;
  btn_label?: string;
  hide_btn?: boolean;
  predictions?: { [year: number]: YearlyPriceData }[] | null;
  year?: number;
  symbol?: string;
}

export const YearlyPricePrediction: React.FC<YearlyPricePredictionProps> = ({
  btn_label,
  btn_link,
  hide_btn = false,
  predictions,
  symbol = '',
  year,
}) => {
  if (!predictions) {
    return null;
  }

  let predictionData: { [year: number]: YearlyPriceData } | null = null;

  predictionData = predictions?.[symbol];
  if (!predictionData) {
    return null;
  }

  return (
    <div className="block my-4">
      {year && year > 0 && (
        <>
          <div className="w-full flex flex-row gap-2 mb-2">
            <div className="w-1/3">
              <PricePredictionCard
                icon="/next-assets/images/trend-icons/trend-bullish.png"
                title="Bullish Prediction"
                value={predictionData?.[year]?.max || '—'}
              />
            </div>
            <div className="w-1/3">
              <PricePredictionCard
                icon="/next-assets/images/trend-icons/trend-average.png"
                title="Average Prediction"
                value={predictionData?.[year]?.avg || '—'}
              />
            </div>
            <div className="w-1/3">
              <PricePredictionCard
                icon="/next-assets/images/trend-icons/trend-bearish.png"
                title="Bearish Prediction"
                value={predictionData?.[year]?.min || '—'}
              />
            </div>
          </div>
          {btn_link && btn_label && !hide_btn && <PricePredictionButton btn_label={btn_label} btn_link={btn_link} />}
        </>
      )}
    </div>
  );
};

const PricePredictionCard: React.FC<{ title: string; value: string; icon: string }> = ({ icon, title, value }) => {
  return (
    <div className="w-full flex flex-col items-center p-4 border rounded shadow-sm">
      <Image alt={title} height={64} src={icon} width={64} />
      <div className="text-md my-1 text-gray-500">{title}</div>
      <div className="text-2xl font-bold text-gray-900">{value}</div>
    </div>
  );
};
